import React from "react";

interface GxPrimaryButtonShadowProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
}

const GxPrimaryButtonShadow: React.FC<GxPrimaryButtonShadowProps> = ({
  label,
  onClick,
  type = "button",
  disabled = false,
  className = " gx-p12-m w-full max-w-36.25 min-w-25 px-6 py-2.5 bg-(--gx-prime-theme) text-white rounded-full hover:bg-gray-800 font-medium transition-colors shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      {label}
    </button>
  );
};

export default GxPrimaryButtonShadow;
